import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Operation from "../views/Operation.vue";
import Search from "../views/Search.vue";
import Clients from "../views/Clients.vue";

import Promotions from "../views/Promotions.vue";
import Notifications from "../views/Notifications.vue";

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    //component: Vue.$cookies.get("token") ? Home : Login,
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/operation/:id",
    name: "Operation",
    component: Operation,
  },
  {
    path: "/promotions/:id?",
    name: "Promotions",
    component: Promotions,
  },
  {
    path: "/notifications/:id?",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/search",
    name: "Search",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ "../views/Search.vue"),
    component: Search,
  },
  {
    path: "/clients",
    name: "Clients",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ "../views/Clients.vue"),
    component: Clients,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !Vue.$cookies.get("token"))
    next({ name: "Login" });
  else next();
});

export default router;
